export interface Video {
  id: string;
  title: string;
  slug: string;
  category: string;
  platform: string;
  thumbnail: string;
  rating: number;
  episode: string;
  description: string;
  actors: string[];
  director: string;
  year: number;
  region: string;
  tags: string[];
  views: number;
  isHot: boolean;
  isNew: boolean;
  createdAt: string;
}

export const videos: Video[] = [
  {
    id: 'v001',
    title: '长安十二时辰',
    slug: 'changan-shiershichen',
    category: 'reboju',
    platform: 'yaojing',
    thumbnail: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20drama%20Tang%20Dynasty%20scene%20with%20warriors%20in%20traditional%20armor%20at%20night%20market%2C%20cinematic%20lighting%2C%20epic%20atmosphere%2C%20historical%20costume%20drama%2C%20warm%20lantern%20glow%2C%20mysterious%20mood%2C%20film%20poster%20style%20with%20dramatic%20shadows%2C%20clean%20background&width=800&height=450&seq=video-changan&orientation=landscape',
    rating: 9.1,
    episode: '更新至48集',
    description: '唐天宝三年，元月十四日，长安城。一股被称为"狼卫"的势力潜入长安，靖安司司丞李必临危受命，以"大案牍术"选出死囚张小敬，两人要在十二时辰内拯救长安。',
    actors: ['雷佳音', '易烊千玺', '周一围', '热依扎'],
    director: '曹盾',
    year: 2019,
    region: '中国大陆',
    tags: ['古装', '悬疑', '历史', '动作'],
    views: 2350000,
    isHot: true,
    isNew: false,
    createdAt: '2024-12-01',
  },
  {
    id: 'v002',
    title: '狂飙',
    slug: 'kuangbiao',
    category: 'reboju',
    platform: 'taohua',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20police%20officer%20in%20dark%20suit%20standing%20on%20city%20street%20at%20night%20with%20neon%20lights%2C%20intense%20thriller%20atmosphere%2C%20film%20noir%20style%2C%20dramatic%20lighting%2C%20mysterious%20mood%2C%20clean%20composition%2C%20poster%20quality&width=800&height=450&seq=video-kuangbiao&orientation=landscape',
    rating: 9.5,
    episode: '全39集',
    description: '一部扫黑除恶坚决斗争的回忆录，横跨二十年的群像叙事全景式展现时代变迁下的黑白较量与复杂人性。',
    actors: ['张译', '张颂文', '李一桐', '张志坚'],
    director: '徐纪周',
    year: 2023,
    region: '中国大陆',
    tags: ['犯罪', '剧情', '悬疑', '扫黑'],
    views: 5800000,
    isHot: true,
    isNew: false,
    createdAt: '2024-11-15',
  },
  {
    id: 'v003',
    title: '庆余年第二季',
    slug: 'qingyunian-2',
    category: 'reboju',
    platform: 'pingguo',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20fantasy%20drama%20young%20man%20in%20elegant%20traditional%20silk%20robe%20holding%20a%20fan%20in%20ancient%20palace%20garden%2C%20soft%20natural%20light%2C%20ethereal%20atmosphere%2C%20warm%20golden%20tones%2C%20cinematic%20composition%2C%20poster%20style%2C%20clean%20background&width=800&height=450&seq=video-qingyunian&orientation=landscape',
    rating: 9.3,
    episode: '更新至16集',
    description: '范闲归来，面对抱月楼迷局、春闱危机等一系列考验，他将如何化险为夷，一步步揭示这个世界的终极秘密。',
    actors: ['张若昀', '李沁', '陈道明', '吴刚'],
    director: '孙皓',
    year: 2024,
    region: '中国大陆',
    tags: ['古装', '奇幻', '权谋', '喜剧'],
    views: 4200000,
    isHot: true,
    isNew: true,
    createdAt: '2025-06-10',
  },
  {
    id: 'v004',
    title: '三体',
    slug: 'santi',
    category: 'reboju',
    platform: 'liulian',
    thumbnail: 'https://readdy.ai/api/search-image?query=Sci-fi%20drama%20three%20suns%20in%20alien%20sky%20above%20futuristic%20observatory%20building%2C%20cosmic%20mystery%20atmosphere%2C%20deep%20space%20with%20stars%2C%20dramatic%20cinematic%20lighting%2C%20philosophical%20mood%2C%20film%20poster%20style%2C%20clean%20dark%20background&width=800&height=450&seq=video-santi&orientation=landscape',
    rating: 8.7,
    episode: '全30集',
    description: '纳米科学家汪淼被警官史强带入联合作战中心，潜入神秘组织"科学边界"，揭开三体世界的神秘面纱。',
    actors: ['张鲁一', '于和伟', '陈瑾', '王子文'],
    director: '杨磊',
    year: 2023,
    region: '中国大陆',
    tags: ['科幻', '悬疑', '剧情', '改编'],
    views: 3100000,
    isHot: true,
    isNew: false,
    createdAt: '2024-10-01',
  },
  {
    id: 'v005',
    title: '流浪地球2',
    slug: 'liulangdiqiu-2',
    category: 'dianying',
    platform: 'yaojing',
    thumbnail: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20scene%20giant%20spaceship%20engine%20glowing%20blue%20in%20deep%20space%20with%20earth%20in%20background%2C%20dramatic%20cinematic%20lighting%2C%20grand%20scale%2C%20atmospheric%2C%20film%20poster%20quality%2C%20clean%20composition&width=800&height=450&seq=video-liulangdiqiu&orientation=landscape',
    rating: 8.9,
    episode: 'HD高清',
    description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器寻找新的家园。然而宇宙之路危机四伏，为了拯救地球，年轻人再次挺身而出。',
    actors: ['吴京', '刘德华', '李雪健', '沙溢'],
    director: '郭帆',
    year: 2023,
    region: '中国大陆',
    tags: ['科幻', '灾难', '冒险', '特效'],
    views: 4500000,
    isHot: true,
    isNew: false,
    createdAt: '2024-09-20',
  },
  {
    id: 'v006',
    title: '满江红',
    slug: 'manjianghong',
    category: 'dianying',
    platform: 'taohua',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20mystery%20film%20ancient%20courtyard%20at%20night%20with%20red%20lanterns%20hanging%2C%20soldiers%20in%20traditional%20armor%2C%20dark%20atmosphere%20with%20warm%20lantern%20glow%2C%20dramatic%20tension%2C%20cinematic%20poster%20style%2C%20clean%20composition&width=800&height=450&seq=video-manjianghong&orientation=landscape',
    rating: 8.5,
    episode: 'HD高清',
    description: '南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。会谈前夜，金国使者死在宰相驻地，一个小兵与亲兵营副统领被裹挟进巨大阴谋之中。',
    actors: ['沈腾', '易烊千玺', '张译', '雷佳音'],
    director: '张艺谋',
    year: 2023,
    region: '中国大陆',
    tags: ['历史', '悬疑', '喜剧', '剧情'],
    views: 3200000,
    isHot: true,
    isNew: false,
    createdAt: '2024-08-15',
  },
  {
    id: 'v007',
    title: '繁花',
    slug: 'fanhua',
    category: 'reboju',
    platform: 'douhua',
    thumbnail: 'https://readdy.ai/api/search-image?query=Shanghai%20in%201990s%20neon%20lit%20street%20with%20elegant%20woman%20in%20cheongsam%20walking%2C%20vintage%20atmosphere%2C%20warm%20golden%20street%20lights%2C%20retro%20Chinese%20drama%20aesthetic%2C%20nostalgic%20mood%2C%20film%20poster%20style%2C%20clean%20composition&width=800&height=450&seq=video-fanhua&orientation=landscape',
    rating: 9.2,
    episode: '全30集',
    description: '九十年代的上海，阿宝从平凡的街头青年，凭借改革开放的春风和自己的打拼，成为商界后起之秀，黄河路上无人不晓。',
    actors: ['胡歌', '马伊琍', '唐嫣', '辛芷蕾'],
    director: '王家卫',
    year: 2024,
    region: '中国大陆',
    tags: ['剧情', '年代', '商战', '爱情'],
    views: 2800000,
    isHot: true,
    isNew: false,
    createdAt: '2024-11-01',
  },
  {
    id: 'v008',
    title: '鬼灭之刃 柱训练篇',
    slug: 'guimiezhiren-zhu',
    category: 'dongman',
    platform: 'yaojing',
    thumbnail: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20young%20swordsman%20with%20green%20checkered%20haori%20holding%20katana%20in%20moonlight%2C%20dramatic%20action%20pose%2C%20cherry%20blossom%20petals%20floating%2C%20dynamic%20composition%2C%20vibrant%20colors%2C%20anime%20poster%20art%2C%20clean%20background&width=800&height=450&seq=video-guimie&orientation=landscape',
    rating: 9.0,
    episode: '更新至8集',
    description: '炭治郎一行人来到鬼杀队当主产屋敷耀哉的宅邸，参加由柱主持的特别训练。各柱将亲自指导队员，为最终决战做准备。',
    actors: ['花江夏树', '鬼头明里', '下野纮', '松冈祯丞'],
    director: '外崎春雄',
    year: 2024,
    region: '日本',
    tags: ['热血', '战斗', '奇幻', '冒险'],
    views: 1800000,
    isHot: true,
    isNew: true,
    createdAt: '2025-05-20',
  },
  {
    id: 'v009',
    title: '咒术回战 第二季',
    slug: 'zhoushuhuizhan-2',
    category: 'dongman',
    platform: 'taohua',
    thumbnail: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20white%20haired%20sorcerer%20with%20blindfold%20in%20combat%20stance%20surrounded%20by%20blue%20energy%2C%20dynamic%20action%20scene%2C%20urban%20Tokyo%20background%2C%20intense%20lighting%2C%20anime%20poster%20art%20style%2C%20clean%20composition&width=800&height=450&seq=video-zhoushu&orientation=landscape',
    rating: 9.4,
    episode: '全23集',
    description: '最强的咒术师五条悟与最强的诅咒师夏油杰，在高专时代的青春故事。以及涉谷事变篇的震撼展开。',
    actors: ['中村悠一', '樱井孝宏', '远藤绫', '子安武人'],
    director: '朴性厚',
    year: 2023,
    region: '日本',
    tags: ['热血', '战斗', '奇幻', '校园'],
    views: 2100000,
    isHot: false,
    isNew: false,
    createdAt: '2024-07-10',
  },
  {
    id: 'v010',
    title: '奔跑吧 第八季',
    slug: 'benpaoba-8',
    category: 'zongyi',
    platform: 'pingguo',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20group%20of%20celebrities%20running%20and%20laughing%20on%20colorful%20outdoor%20set%20with%20balloons%2C%20bright%20sunny%20day%2C%20energetic%20atmosphere%2C%20fun%20vibe%2C%20entertainment%20poster%20style%2C%20clean%20composition&width=800&height=450&seq=video-benpao&orientation=landscape',
    rating: 8.3,
    episode: '更新至12期',
    description: '新一季的跑男家族再次集结，更多精彩游戏环节，更多欢笑和感动。',
    actors: ['李晨', '郑恺', '杨颖', '白鹿'],
    director: '姚译添',
    year: 2024,
    region: '中国大陆',
    tags: ['综艺', '户外', '竞技', '搞笑'],
    views: 1500000,
    isHot: false,
    isNew: true,
    createdAt: '2025-04-15',
  },
  {
    id: 'v011',
    title: '地球脉动 第三季',
    slug: 'diqiumaidong-3',
    category: 'jilupian',
    platform: 'liulian',
    thumbnail: 'https://readdy.ai/api/search-image?query=Nature%20documentary%20scene%20majestic%20mountain%20landscape%20with%20eagle%20soaring%20in%20golden%20sunset%20light%2C%20breathtaking%20wilderness%2C%20National%20Geographic%20style%2C%20cinematic%20quality%2C%20warm%20atmospheric%20tones%2C%20clean%20composition&width=800&height=450&seq=video-diqiu&orientation=landscape',
    rating: 9.8,
    episode: '全8集',
    description: '从海洋深处到最偏远的丛林，造访地球上众多令人惊叹的栖息地，探索动物的神奇行为。',
    actors: ['大卫·爱登堡'],
    director: 'BBC Studios',
    year: 2023,
    region: '英国',
    tags: ['自然', '动物', '探险', 'BBC'],
    views: 980000,
    isHot: false,
    isNew: false,
    createdAt: '2024-06-01',
  },
  {
    id: 'v012',
    title: '孤注一掷',
    slug: 'guzhuyizhi',
    category: 'dianying',
    platform: 'douhua',
    thumbnail: 'https://readdy.ai/api/search-image?query=Crime%20thriller%20film%20scene%20dark%20room%20with%20computer%20screens%20and%20phone%20banks%2C%20tense%20atmosphere%2C%20modern%20Chinese%20drama%2C%20suspenseful%20mood%2C%20digital%20crime%20theme%2C%20film%20poster%20style%2C%20clean%20dark%20composition&width=800&height=450&seq=video-guzhu&orientation=landscape',
    rating: 8.6,
    episode: 'HD高清',
    description: '程序员潘生和模特安娜被海外高薪招聘吸引，出国淘金却意外落入境外诈骗工厂的陷阱。',
    actors: ['张艺兴', '金晨', '咏梅', '王传君'],
    director: '申奥',
    year: 2023,
    region: '中国大陆',
    tags: ['犯罪', '剧情', '诈骗', '现实'],
    views: 2700000,
    isHot: false,
    isNew: false,
    createdAt: '2024-05-01',
  },
];